import classNames from 'classnames';
import { Checkbox } from '../Checkbox/Checkbox';
import { DropdownButton } from '../DropdownButton/DropdownButton';
import { ArrowDownIcon } from '../icons';
import styles from './CheckboxSelectSimple.module.scss';
import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';

export interface ICheckboxSelectSimpleOption {
  name: string;
  value: string;
}
interface IProps {
  className?: string;
  title: string;
  items: ICheckboxSelectSimpleOption[];
  selectedItems?: string[];
  onChange: (value: any) => Promise<void>;
}

export function CheckboxSelectSimple({
  className,
  title,
  items,
  selectedItems = [],
  onChange,
}: IProps) {

  const [selected, setSelected] = useState(selectedItems);

  useEffect(() => {
    setSelected(selectedItems);
  }, [selectedItems])

  const onSubmit = async () => {
    await onChange(selected);
  }

  const onReset = async () => {
    await onChange([]);
  }

  const onSelect = useCallback((item: any) => {
    let newSelected;
    if (selected.includes(item.value)) {
      newSelected = _.without(selected, item.value);
    } else {
      newSelected = [...selected, item.value];
    }

    setSelected(newSelected);
  }, [selected]);

  return (
    <DropdownButton
      className={className}
      contentClassName={styles.contentPosition}
      renderButton={({ isOpen, toggle }) => (
        <a
          className={classNames(
            isOpen && styles.titleOpen, selectedItems.length > 0 && styles.titleHighlighted, styles.title,
          )}
          onClick={toggle}
        >
          {title}
          <ArrowDownIcon/>
        </a>
      )}
      renderContent={({ toggle }) => (
        <div className={styles.content}>
          <div className={styles.list}>

            <div className={styles.optionsList}>
              {items.map((item) => (
                <div key={item.value} className={styles.listItem}>
                  <Checkbox
                    value={item.value}
                    onChange={() => onSelect(item)}
                    checked={selected.includes(item.value)}
                  >
                    {item.name}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.clearButton}
              onClick={() => {
                onReset();
                toggle();
              }}
            >
              очистить
            </button>
            <button
              className={styles.submitButton}
              onClick={() => {
                onSubmit();
                toggle();
              }}
            >
              применить
            </button>
          </div>
        </div>
      )}
    />
  );
}
